/* unplugin-vue-components disabled */import { render } from "./BlackWhiteDotAnimation.vue?vue&type=template&id=bc1e3400&scoped=true"
import script from "./BlackWhiteDotAnimation.vue?vue&type=script&lang=js"
export * from "./BlackWhiteDotAnimation.vue?vue&type=script&lang=js"

import "./BlackWhiteDotAnimation.vue?vue&type=style&index=0&id=bc1e3400&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc1e3400"]])

export default __exports__